// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"395":"bec7bfa1","594":"42a6ac37","621":"e8482364"}[chunkId] + ".js";
};